import { render, staticRenderFns } from "./SensorBattery.vue?vue&type=template&id=031f3c65&scoped=true&"
import script from "./SensorBattery.vue?vue&type=script&lang=js&"
export * from "./SensorBattery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031f3c65",
  null
  
)

export default component.exports